import { useCallback, useRef, useState } from "react";

export function useVoiceInput(onTranscript: (text: string) => void) {
	const [isListening, setIsListening] = useState(false);
	const isSupported = "webkitSpeechRecognition" in window || "SpeechRecognition" in window;
	const recognitionRef = useRef<SpeechRecognition | null>(null);

	const start = useCallback(() => {
		const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
		if (!SpeechRecognition) return;

		const recognition = new SpeechRecognition();
		recognition.continuous = false;
		recognition.interimResults = true;
		recognition.lang = "en-US";

		recognition.onstart = () => setIsListening(true);
		recognition.onend = () => setIsListening(false);
		recognition.onerror = () => setIsListening(false);

		recognition.onresult = (event: SpeechRecognitionEvent) => {
			const transcript = Array.from(event.results)
				.map((r) => r[0].transcript)
				.join("");
			if (event.results[event.results.length - 1].isFinal) {
				onTranscript(transcript);
			}
		};

		recognitionRef.current = recognition;
		recognition.start();
	}, [onTranscript]);

	const stop = useCallback(() => {
		recognitionRef.current?.stop();
		setIsListening(false);
	}, []);

	const toggle = useCallback(() => {
		if (isListening) {
			stop();
		} else {
			start();
		}
	}, [isListening, start, stop]);

	return { isListening, isSupported, toggle };
}
